import { ReasonForm } from '@ha/domain';

import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ApAnalyticsService, ClickAnalyticsData, FormFieldValue, FormStepAnalyticsData } from '@ap/analytics';
import { ApContentService } from '@ap/content';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    private readonly contentService = inject(ApContentService);
    private readonly analyticsService = inject(ApAnalyticsService);
    private readonly formName: string = 'Hypotheekafspraak';

    sendFormAnalytics(reasonFormGroup: FormGroup<ReasonForm>): void {
        let formFieldValues: FormFieldValue[] = [
            new FormFieldValue(
                this.contentService.get('reason.sub_header'),
                this.contentService.get(`answer.label.${reasonFormGroup.controls.reason.value}`, null)
            )
        ];

        if (reasonFormGroup.controls.houseReason.value !== null) {
            formFieldValues.push(
                new FormFieldValue(
                    this.contentService.get('reason.housing.header'),
                    this.contentService.get(`answer.label.${reasonFormGroup.controls.houseReason.value}`, null)
                )
            );
        }
        if (reasonFormGroup.controls.refinance.value !== null) {
            formFieldValues.push(
                new FormFieldValue(
                    this.contentService.get('reason.refinance.header'),
                    this.contentService.get(`answer.label.${reasonFormGroup.controls.refinance.value}`, null)
                )
            );
        }

        this.analyticsService.push(new FormStepAnalyticsData(this.formName, 'Angular', this.formName, 1, 'success', formFieldValues));
    }

    sendClickAnalytics(contentKey: string): void {
        const clickData: ClickAnalyticsData = new ClickAnalyticsData(this.contentService.get(contentKey), 'click', this.formName);

        this.analyticsService.push(clickData);
    }
}
